import Blob from "cross-blob";
import { Document, ISectionOptions, Packer, Paragraph } from "docx";
import flattenDeep from "lodash/flattenDeep";

import { ApplicantRefereeFull } from "@/lib/prisma";

import { docStyles } from "./common";
import { numberingStyle } from "./common/numbering";
import { DocGenerator } from "..";
import { renderProseMirrorSchemaToGoogleDoc } from "../proseMirror";

interface SelfServiceRefereeDocArgs {
  applicantReferee: ApplicantRefereeFull;
}

export const createSelfServiceRefereeDoc: DocGenerator<
  SelfServiceRefereeDocArgs
> = async (t, { applicantReferee }) => {
  const document = new Document({
    styles: docStyles,
    numbering: numberingStyle,
    sections: [
      {
        children: flattenDeep<ISectionOptions["children"][0] | null>([
          [
            applicantReferee.aboutReferee,
            applicantReferee.meetAndActivities,
            applicantReferee.refereeDidSee,
            ...(applicantReferee.workedTogether
              ? [applicantReferee.howRefereeKnowAboutYou]
              : []),
            applicantReferee.conclusion,
          ].map((text) =>
            text
              ? [
                  renderProseMirrorSchemaToGoogleDoc(text, "-"),
                  new Paragraph({
                    style: "wellSpaced",
                  }),
                ]
              : null
          ),
        ]).filter((x): x is ISectionOptions["children"][0] => x !== null),
      },
    ],
  });

  return new Blob([await Packer.toBuffer(document)]);
};
